module.exports = __webpack_public_path__ + "img/CM-KT-25-Chevy-Established.ac0161e2.jpg";